var map = {
	"./Arrow/Arrow_Circle_Down.svg": 50088,
	"./Arrow/Arrow_Circle_Down_Left.svg": 992,
	"./Arrow/Arrow_Circle_Down_Right.svg": 36815,
	"./Arrow/Arrow_Circle_Left.svg": 52647,
	"./Arrow/Arrow_Circle_Right.svg": 59906,
	"./Arrow/Arrow_Circle_Up.svg": 41883,
	"./Arrow/Arrow_Circle_Up_Left.svg": 69925,
	"./Arrow/Arrow_Circle_Up_Right.svg": 52328,
	"./Arrow/Arrow_Down_LG.svg": 63795,
	"./Arrow/Arrow_Down_Left_LG.svg": 8301,
	"./Arrow/Arrow_Down_Left_MD.svg": 64001,
	"./Arrow/Arrow_Down_Left_SM.svg": 26862,
	"./Arrow/Arrow_Down_MD.svg": 63523,
	"./Arrow/Arrow_Down_Right_LG.svg": 42558,
	"./Arrow/Arrow_Down_Right_MD.svg": 29930,
	"./Arrow/Arrow_Down_Right_SM.svg": 90049,
	"./Arrow/Arrow_Down_SM.svg": 31564,
	"./Arrow/Arrow_Down_Up.svg": 46087,
	"./Arrow/Arrow_Left_LG.svg": 72326,
	"./Arrow/Arrow_Left_MD.svg": 70962,
	"./Arrow/Arrow_Left_Right.svg": 22377,
	"./Arrow/Arrow_Left_SM.svg": 84585,
	"./Arrow/Arrow_Reload_02.svg": 14119,
	"./Arrow/Arrow_Right_LG.svg": 18859,
	"./Arrow/Arrow_Right_MD.svg": 61115,
	"./Arrow/Arrow_Right_SM.svg": 80804,
	"./Arrow/Arrow_Sub_Down_Left.svg": 84188,
	"./Arrow/Arrow_Sub_Down_Right.svg": 74211,
	"./Arrow/Arrow_Sub_Left_Down.svg": 70470,
	"./Arrow/Arrow_Sub_Left_Up.svg": 55805,
	"./Arrow/Arrow_Sub_Right_Down.svg": 9033,
	"./Arrow/Arrow_Sub_Right_Up.svg": 38662,
	"./Arrow/Arrow_Sub_Up_Left.svg": 24777,
	"./Arrow/Arrow_Sub_Up_Right.svg": 82324,
	"./Arrow/Arrow_Undo_Down_Left.svg": 46102,
	"./Arrow/Arrow_Undo_Down_Right.svg": 61013,
	"./Arrow/Arrow_Undo_Up_Left.svg": 70679,
	"./Arrow/Arrow_Undo_Up_Right.svg": 5618,
	"./Arrow/Arrow_Up_LG.svg": 27682,
	"./Arrow/Arrow_Up_Left_LG.svg": 57422,
	"./Arrow/Arrow_Up_Left_MD.svg": 1882,
	"./Arrow/Arrow_Up_Left_SM.svg": 20145,
	"./Arrow/Arrow_Up_MD.svg": 93662,
	"./Arrow/Arrow_Up_Right_LG.svg": 19379,
	"./Arrow/Arrow_Up_Right_MD.svg": 61635,
	"./Arrow/Arrow_Up_Right_SM.svg": 69324,
	"./Arrow/Arrow_Up_SM.svg": 25101,
	"./Arrow/Arrows_Reload_01.svg": 91859,
	"./Arrow/Caret_Circle_Down.svg": 34846,
	"./Arrow/Caret_Circle_Left.svg": 39765,
	"./Arrow/Caret_Circle_Right.svg": 72728,
	"./Arrow/Caret_Circle_Up.svg": 99125,
	"./Arrow/Caret_Down_MD.svg": 30397,
	"./Arrow/Caret_Down_SM.svg": 50146,
	"./Arrow/Caret_Left_SM.svg": 94439,
	"./Arrow/Caret_Right_SM.svg": 49890,
	"./Arrow/Caret_Up_MD.svg": 43044,
	"./Arrow/Caret_Up_SM.svg": 64551,
	"./Arrow/Chevron_Down.svg": 80063,
	"./Arrow/Chevron_Down_Duo.svg": 79670,
	"./Arrow/Chevron_Left.svg": 86976,
	"./Arrow/Chevron_Left_Duo.svg": 27645,
	"./Arrow/Chevron_Left_MD.svg": 78028,
	"./Arrow/Chevron_Right.svg": 72559,
	"./Arrow/Chevron_Right_Duo.svg": 90246,
	"./Arrow/Chevron_Right_MD.svg": 22149,
	"./Arrow/Chevron_Up.svg": 86128,
	"./Arrow/Chevron_Up_Duo.svg": 68717,
	"./Arrow/Expand.svg": 42275,
	"./Arrow/Shrink.svg": 3896,
	"./Arrow/Unfold_Less.svg": 27937,
	"./Arrow/Unfold_More.svg": 26561,
	"./Calendar/Alarm.svg": 70573,
	"./Calendar/Calendar.svg": 21348,
	"./Calendar/Calendar_Add.svg": 54968,
	"./Calendar/Calendar_Check.svg": 86305,
	"./Calendar/Calendar_Close.svg": 33405,
	"./Calendar/Calendar_Days.svg": 76506,
	"./Calendar/Calendar_Event.svg": 78585,
	"./Calendar/Calendar_Remove.svg": 83019,
	"./Calendar/Calendar_Week.svg": 53771,
	"./Calendar/Clock.svg": 60508,
	"./Calendar/Timer.svg": 11489,
	"./Calendar/Timer_Add.svg": 71293,
	"./Calendar/Timer_Close.svg": 74664,
	"./Calendar/Timer_Remove.svg": 15684,
	"./Communication/Bell.svg": 72257,
	"./Communication/Bell_Add.svg": 75773,
	"./Communication/Bell_Close.svg": 81896,
	"./Communication/Bell_Notification.svg": 96585,
	"./Communication/Bell_Off.svg": 5523,
	"./Communication/Bell_Remove.svg": 21476,
	"./Communication/Bell_Ring.svg": 53418,
	"./Communication/Chat.svg": 13184,
	"./Communication/Chat_Add.svg": 1420,
	"./Communication/Chat_Check.svg": 6477,
	"./Communication/Chat_Circle.svg": 90283,
	"./Communication/Chat_Circle_Add.svg": 21867,
	"./Communication/Chat_Circle_Check.svg": 58166,
	"./Communication/Chat_Circle_Close.svg": 4466,
	"./Communication/Chat_Circle_Dots.svg": 58082,
	"./Communication/Chat_Circle_Remove.svg": 24010,
	"./Communication/Chat_Close.svg": 73113,
	"./Communication/Chat_Conversation.svg": 19866,
	"./Communication/Chat_Conversation_Circle.svg": 10969,
	"./Communication/Chat_Dots.svg": 7323,
	"./Communication/Chat_Remove.svg": 88511,
	"./Communication/Mail.svg": 66487,
	"./Communication/Mail_Open.svg": 83650,
	"./Communication/Paper_Plane.svg": 28055,
	"./Communication/Phone.svg": 46890,
	"./Communication/Share_Android.svg": 70087,
	"./Communication/Share_iOS_Export.svg": 29658,
	"./Edit/Add_Column.svg": 61354,
	"./Edit/Add_Minus_Square.svg": 31982,
	"./Edit/Add_Plus.svg": 96428,
	"./Edit/Add_Plus_Circle.svg": 42183,
	"./Edit/Add_Plus_Square.svg": 37654,
	"./Edit/Add_Row.svg": 61432,
	"./Edit/Add_To_Queue.svg": 13475,
	"./Edit/Bold.svg": 64841,
	"./Edit/Close_Circle.svg": 27303,
	"./Edit/Close_Square.svg": 39126,
	"./Edit/Columns.svg": 86625,
	"./Edit/Combine_Cells.svg": 72569,
	"./Edit/Copy.svg": 8879,
	"./Edit/Crop.svg": 35650,
	"./Edit/Delete_Column.svg": 37346,
	"./Edit/Delete_Row.svg": 68112,
	"./Edit/Double_Quotes_L.svg": 13432,
	"./Edit/Double_Quotes_R.svg": 30974,
	"./Edit/Edit_Pencil_01.svg": 12542,
	"./Edit/Edit_Pencil_02.svg": 24637,
	"./Edit/Edit_Pencil_Line_01.svg": 22193,
	"./Edit/Edit_Pencil_Line_02.svg": 41794,
	"./Edit/Figma.svg": 36876,
	"./Edit/Font.svg": 97151,
	"./Edit/Heading.svg": 90130,
	"./Edit/Heading_H1.svg": 45112,
	"./Edit/Heading_H2.svg": 95851,
	"./Edit/Heading_H3.svg": 81242,
	"./Edit/Heading_H4.svg": 42341,
	"./Edit/Heading_H5.svg": 91172,
	"./Edit/Heading_H6.svg": 34295,
	"./Edit/Hide.svg": 16952,
	"./Edit/Italic.svg": 22728,
	"./Edit/Layer.svg": 97383,
	"./Edit/Layers.svg": 2006,
	"./Edit/List_Add.svg": 51596,
	"./Edit/List_Check.svg": 77805,
	"./Edit/List_Checklist.svg": 68117,
	"./Edit/List_Ordered.svg": 56858,
	"./Edit/List_Remove.svg": 50687,
	"./Edit/List_Unordered.svg": 35609,
	"./Edit/Mention.svg": 73078,
	"./Edit/Move.svg": 13183,
	"./Edit/Move_Horizontal.svg": 70638,
	"./Edit/Move_Vertical.svg": 67860,
	"./Edit/Paperclip_Attechment_Horizontal.svg": 36227,
	"./Edit/Paperclip_Attechment_Tilt.svg": 11970,
	"./Edit/Paragraph.svg": 29090,
	"./Edit/Path.svg": 3485,
	"./Edit/Redo.svg": 53360,
	"./Edit/Remove_Minus.svg": 74725,
	"./Edit/Remove_Minus_Circle.svg": 23132,
	"./Edit/Rows.svg": 2711,
	"./Edit/Ruler.svg": 1916,
	"./Edit/Select_Multiple.svg": 27443,
	"./Edit/Show.svg": 5707,
	"./Edit/Single_Quotes_L.svg": 83657,
	"./Edit/Single_Quotes_R.svg": 68591,
	"./Edit/Sort_Ascending.svg": 83447,
	"./Edit/Sort_Descending.svg": 27885,
	"./Edit/Strikethrough.svg": 1705,
	"./Edit/Swatches_Palette.svg": 45712,
	"./Edit/Table.svg": 91964,
	"./Edit/Table_Add.svg": 9504,
	"./Edit/Table_Remove.svg": 99811,
	"./Edit/Text.svg": 81581,
	"./Edit/Text_Align_Center.svg": 2041,
	"./Edit/Text_Align_Justify.svg": 99666,
	"./Edit/Text_Align_Left.svg": 80401,
	"./Edit/Text_Align_Right.svg": 34396,
	"./Edit/Underline.svg": 92308,
	"./Edit/Undo.svg": 18178,
	"./Environment/Bulb.svg": 73914,
	"./Environment/Coffe_To_Go.svg": 37095,
	"./Environment/Coffee.svg": 6591,
	"./Environment/Cookie.svg": 58817,
	"./Environment/Cupcake.svg": 63933,
	"./Environment/First_Aid.svg": 80968,
	"./Environment/Leaf.svg": 10323,
	"./Environment/Moon.svg": 83308,
	"./Environment/Planet.svg": 49149,
	"./Environment/Puzzle.svg": 34715,
	"./Environment/Rainbow.svg": 16159,
	"./Environment/Sun.svg": 59967,
	"./Environment/Water_Drop.svg": 61520,
	"./File/Archive.svg": 86348,
	"./File/Cloud.svg": 49289,
	"./File/Cloud_Add.svg": 62453,
	"./File/Cloud_Check.svg": 63220,
	"./File/Cloud_Close.svg": 1696,
	"./File/Cloud_Download.svg": 86628,
	"./File/Cloud_Off.svg": 45723,
	"./File/Cloud_Remove.svg": 11116,
	"./File/Cloud_Upload.svg": 89271,
	"./File/Download_Package.svg": 57059,
	"./File/File_Add.svg": 67844,
	"./File/File_Blank.svg": 45867,
	"./File/File_Check.svg": 68165,
	"./File/File_Close.svg": 31313,
	"./File/File_Code.svg": 20292,
	"./File/File_Document.svg": 10244,
	"./File/File_Download.svg": 87875,
	"./File/File_Edit.svg": 96923,
	"./File/File_Remove.svg": 50343,
	"./File/File_Search.svg": 3155,
	"./File/File_Upload.svg": 57292,
	"./File/Files.svg": 63131,
	"./File/Folder.svg": 78362,
	"./File/Folder_Add.svg": 24978,
	"./File/Folder_Check.svg": 38991,
	"./File/Folder_Close.svg": 56643,
	"./File/Folder_Code.svg": 96582,
	"./File/Folder_Document.svg": 28578,
	"./File/Folder_Download.svg": 46613,
	"./File/Folder_Edit.svg": 88605,
	"./File/Folder_Open.svg": 85677,
	"./File/Folder_Remove.svg": 35949,
	"./File/Folder_Search.svg": 80393,
	"./File/Folder_Upload.svg": 65250,
	"./File/Folders.svg": 76101,
	"./File/Note.svg": 81126,
	"./File/Note_Edit.svg": 31937,
	"./File/Note_Search.svg": 61485,
	"./File/Notebook.svg": 47053,
	"./Interface/Book.svg": 44326,
	"./Interface/Book_Open.svg": 85329,
	"./Interface/Bookmark.svg": 18337,
	"./Interface/Chart_Bar_Horizontal_01.svg": 52714,
	"./Interface/Chart_Bar_Vertical_01.svg": 72936,
	"./Interface/Chart_Line.svg": 9952,
	"./Interface/Chart_Pie.svg": 96744,
	"./Interface/Check.svg": 507,
	"./Interface/Check_All.svg": 63323,
	"./Interface/Check_All_Big.svg": 98844,
	"./Interface/Check_Big.svg": 23324,
	"./Interface/Checkbox_Check.svg": 11647,
	"./Interface/Checkbox_Fill.svg": 28430,
	"./Interface/Checkbox_Unchecked.svg": 57271,
	"./Interface/Command.svg": 1484,
	"./Interface/Credit_Card_01.svg": 83259,
	"./Interface/Credit_Card_02.svg": 51368,
	"./Interface/Download.svg": 90265,
	"./Interface/Drag_Horizontal.svg": 94294,
	"./Interface/Drag_Vertical.svg": 79980,
	"./Interface/Dummy_Circle.svg": 45574,
	"./Interface/Dummy_Circle_Small.svg": 37690,
	"./Interface/Dummy_Square.svg": 40315,
	"./Interface/Dummy_Square_Small.svg": 16835,
	"./Interface/Exit.svg": 19485,
	"./Interface/External_Link.svg": 23071,
	"./Interface/Filter.svg": 91427,
	"./Interface/Filter_Off.svg": 89965,
	"./Interface/Gift.svg": 11403,
	"./Interface/Handbag.svg": 6160,
	"./Interface/Heart_01.svg": 40043,
	"./Interface/Heart_02.svg": 81976,
	"./Interface/Instance.svg": 87116,
	"./Interface/Label.svg": 22117,
	"./Interface/Line_L.svg": 7210,
	"./Interface/Line_M.svg": 59675,
	"./Interface/Line_S.svg": 28013,
	"./Interface/Line_Xl.svg": 19278,
	"./Interface/Link.svg": 7361,
	"./Interface/Link_Break.svg": 27089,
	"./Interface/Link_Horizontal.svg": 52988,
	"./Interface/Link_Horizontal_Off.svg": 68058,
	"./Interface/Link_Vertical.svg": 71754,
	"./Interface/Loading.svg": 43435,
	"./Interface/Lock.svg": 82248,
	"./Interface/Lock_Open.svg": 99187,
	"./Interface/Log_Out.svg": 92164,
	"./Interface/Magnifying_Glass_Minus.svg": 28154,
	"./Interface/Magnifying_Glass_Plus.svg": 9426,
	"./Interface/Main_Component.svg": 17034,
	"./Interface/Option.svg": 67318,
	"./Interface/Radio_Fill.svg": 54434,
	"./Interface/Radio_Unchecked.svg": 68131,
	"./Interface/Search_Magnifying_Glass.svg": 99334,
	"./Interface/Settings.svg": 83358,
	"./Interface/Settings_Future.svg": 16,
	"./Interface/Shopping_Bag_01.svg": 62824,
	"./Interface/Shopping_Bag_02.svg": 44187,
	"./Interface/Shopping_Cart_01.svg": 57472,
	"./Interface/Shopping_Cart_02.svg": 12019,
	"./Interface/Slider_01.svg": 99808,
	"./Interface/Slider_02.svg": 90547,
	"./Interface/Slider_03.svg": 76322,
	"./Interface/Star.svg": 76593,
	"./Interface/Suitcase.svg": 8142,
	"./Interface/Swicht_Left.svg": 74809,
	"./Interface/Swicht_Right.svg": 93732,
	"./Interface/Tag.svg": 35487,
	"./Interface/Ticket_Voucher.svg": 14578,
	"./Interface/Trash_Empty.svg": 44727,
	"./Interface/Trash_Full.svg": 27883,
	"./Interface/Trending_Down.svg": 14769,
	"./Interface/Trending_Up.svg": 94414,
	"./Media/Airplay.svg": 59676,
	"./Media/Chromecast.svg": 5097,
	"./Media/Forward.svg": 33753,
	"./Media/Headphones.svg": 86551,
	"./Media/Image_01.svg": 4877,
	"./Media/Image_02.svg": 75758,
	"./Media/Pause.svg": 53984,
	"./Media/Pause_Circle.svg": 22603,
	"./Media/Play.svg": 74056,
	"./Media/Play_Circle.svg": 99219,
	"./Media/Rewind.svg": 36247,
	"./Media/Shuffle.svg": 31805,
	"./Media/Skip_Back.svg": 81791,
	"./Media/Skip_Forward.svg": 28953,
	"./Media/Stop.svg": 47514,
	"./Media/Stop_Circle.svg": 68089,
	"./Media/Volume_Max.svg": 29731,
	"./Media/Volume_Min.svg": 78837,
	"./Media/Volume_Minus.svg": 17485,
	"./Media/Volume_Off.svg": 48854,
	"./Media/Volume_Off_02.svg": 80023,
	"./Media/Volume_Plus.svg": 57791,
	"./Menu/Close_LG.svg": 9851,
	"./Menu/Close_MD.svg": 10155,
	"./Menu/Close_SM.svg": 4052,
	"./Menu/Hamburger_LG.svg": 57456,
	"./Menu/Hamburger_MD.svg": 75168,
	"./Menu/Menu_Alt_01.svg": 55928,
	"./Menu/Menu_Alt_02.svg": 94763,
	"./Menu/Menu_Alt_03.svg": 89498,
	"./Menu/Menu_Alt_04.svg": 24421,
	"./Menu/Menu_Alt_05.svg": 46404,
	"./Menu/Menu_Duo_LG.svg": 47433,
	"./Menu/Menu_Duo_MD.svg": 9389,
	"./Menu/More_Grid_Big.svg": 52787,
	"./Menu/More_Grid_Small.svg": 3991,
	"./Menu/More_Horizontal.svg": 89151,
	"./Menu/More_Vertical.svg": 7165,
	"./Navigation/Building_01.svg": 92508,
	"./Navigation/Building_02.svg": 55183,
	"./Navigation/Building_03.svg": 92606,
	"./Navigation/Building_04.svg": 52513,
	"./Navigation/Car_Auto.svg": 80210,
	"./Navigation/Compass.svg": 62982,
	"./Navigation/Flag.svg": 38504,
	"./Navigation/Globe.svg": 39529,
	"./Navigation/House_01.svg": 26288,
	"./Navigation/House_02.svg": 83331,
	"./Navigation/House_03.svg": 68690,
	"./Navigation/House_Add.svg": 21178,
	"./Navigation/House_Check.svg": 98839,
	"./Navigation/House_Close.svg": 42443,
	"./Navigation/House_Remove.svg": 28133,
	"./Navigation/Map.svg": 32000,
	"./Navigation/Map_Pin.svg": 91116,
	"./Navigation/Navigation.svg": 13132,
	"./Shape/Circle.svg": 43535,
	"./Shape/Octagon.svg": 97748,
	"./Shape/Shield.svg": 33220,
	"./Shape/Square.svg": 92446,
	"./Shape/Triangle.svg": 62195,
	"./Shape/Wavy.svg": 69436,
	"./System/Bar_Bottom.svg": 57750,
	"./System/Bar_Left.svg": 38496,
	"./System/Bar_Right.svg": 40783,
	"./System/Bar_Top.svg": 58988,
	"./System/Camera.svg": 64088,
	"./System/Code.svg": 45522,
	"./System/Cylinder.svg": 85047,
	"./System/Data.svg": 40781,
	"./System/Desktop.svg": 11351,
	"./System/Desktop_Tower.svg": 54609,
	"./System/Devices.svg": 14310,
	"./System/Keyboard.svg": 85378,
	"./System/Laptop.svg": 13257,
	"./System/Mobile.svg": 97187,
	"./System/Mobile_Button.svg": 96262,
	"./System/Monitor.svg": 1653,
	"./System/Monitor_Play.svg": 44006,
	"./System/Mouse.svg": 22110,
	"./System/Moving_Desk.svg": 86633,
	"./System/Printer.svg": 54899,
	"./System/Qr_Code.svg": 23980,
	"./System/Save.svg": 60158,
	"./System/Tablet.svg": 86229,
	"./System/Tablet_Button.svg": 76860,
	"./System/Terminal.svg": 63401,
	"./System/Wifi_High.svg": 54065,
	"./System/Wifi_Low.svg": 45741,
	"./System/Wifi_Medium.svg": 12272,
	"./System/Wifi_None.svg": 68923,
	"./System/Wifi_Off.svg": 95084,
	"./System/Wifi_Problem.svg": 82754,
	"./System/Window.svg": 59093,
	"./System/Window_Check.svg": 16464,
	"./System/Window_Close.svg": 66940,
	"./System/Window_Code_Block.svg": 64241,
	"./System/Window_Sidebar.svg": 61100,
	"./System/Window_Terminal.svg": 34640,
	"./User/User_01.svg": 47148,
	"./User/User_02.svg": 26175,
	"./User/User_03.svg": 97742,
	"./User/User_Add.svg": 18350,
	"./User/User_Card_ID.svg": 72933,
	"./User/User_Check.svg": 54691,
	"./User/User_Circle.svg": 20925,
	"./User/User_Close.svg": 86999,
	"./User/User_Remove.svg": 63241,
	"./User/User_Square.svg": 1584,
	"./User/User_Voice.svg": 84505,
	"./User/Users.svg": 36897,
	"./User/Users_Group.svg": 14197,
	"./Warning/Circle_Check.svg": 40367,
	"./Warning/Circle_Help.svg": 68208,
	"./Warning/Circle_Warning.svg": 99311,
	"./Warning/Help.svg": 34227,
	"./Warning/Info.svg": 2754,
	"./Warning/Octagon_Check.svg": 66982,
	"./Warning/Octagon_Help.svg": 34327,
	"./Warning/Octagon_Warning.svg": 53570,
	"./Warning/Shield_Check.svg": 33348,
	"./Warning/Shield_Warning.svg": 88960,
	"./Warning/Square_Check.svg": 84666,
	"./Warning/Square_Help.svg": 37643,
	"./Warning/Square_Warning.svg": 4094,
	"./Warning/Stop_Sign.svg": 19546,
	"./Warning/Triangle_Check.svg": 59399,
	"./Warning/Triangle_Warning.svg": 87095,
	"./Warning/Warning.svg": 25094,
	"./Warning/Wavy_Check.svg": 15812,
	"./Warning/Wavy_Help.svg": 92989,
	"./Warning/Wavy_Warning.svg": 63936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28188;